<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <!-- //todo test用 -->
  <div
    v-else-if="page==='test'"
    class="page"
  >
    123
  </div>

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import composable from '@/composable/index';

export default {
  setup() {
    const page = ref('initialization');
    const router = useRouter();
    const route = useRoute();

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        await composable.member.initialize();

        switch (route.params.openMode) {
          case 'notification': {
            const info = route.query;
            switch (info.type) {
              case 'satisfactionSurvey':
                if (composable.member.info.status === 'in') {
                  router.replace({
                    path: '/inbox/satisfaction-survey/y',
                    query: info,
                  });
                } else {
                  router.replace({
                    path: '/member/login',
                  });
                }
                break;
              case 'progressReminder':
                router.replace({
                  path: '/progress',
                });
                break;

              default:
                throw Error(`Not Found Notification Type: ${info.type}`);
            }
            break;
          }

          default:
            router.replace('/home');
            break;
        }
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    return {
      page,
      composable,
    };
  },
};
</script>
